/**
 * Snoozyn theme interactions: newsletter popup, quick add from cards
 */
document.addEventListener('DOMContentLoaded', () => {
  initNewsletterPopup();
  initQuickAdd();
});

function initNewsletterPopup() {
  const modal = document.getElementById('SnoozynNewsletterModal');
  if (!modal) return;

  const storageKey = 'snoozyn-newsletter-dismissed';
  const delay = parseInt(modal.dataset.delay || '5000', 10);
  const showOnce = modal.dataset.showOnce !== 'false';

  const openModal = () => {
    if (showOnce && sessionStorage.getItem(storageKey)) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    sessionStorage.setItem(storageKey, '1');
  };

  modal.querySelectorAll('[data-newsletter-close]').forEach((el) => {
    el.addEventListener('click', closeModal);
  });

  modal.querySelector('.snz-newsletter-modal__backdrop')?.addEventListener('click', closeModal);

  document.querySelectorAll('[data-newsletter-open]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });
  });

  if (!showOnce || !sessionStorage.getItem(storageKey)) {
    setTimeout(openModal, delay);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
}

function initQuickAdd() {
  document.addEventListener('click', async (e) => {
    const sizeBtn = e.target.closest('[data-product-size]');
    const addBtn = e.target.closest('[data-add-to-cart]');

    if (sizeBtn) {
      e.preventDefault();
      const card = sizeBtn.closest('.snz-product-card');
      if (!card) return;

      card.querySelectorAll('[data-product-size]').forEach((b) => b.classList.remove('is-selected'));
      sizeBtn.classList.add('is-selected');

      const addButton = card.querySelector('[data-add-to-cart]');
      if (addButton) {
        addButton.dataset.variantId = sizeBtn.dataset.variantId;
        addButton.disabled = false;
      }
      return;
    }

    if (!addBtn || addBtn.disabled) return;

    e.preventDefault();
    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const defaultText = addBtn.dataset.defaultText || 'Add to Bag';
    const loadingText = addBtn.dataset.loadingText || 'Adding…';

    addBtn.disabled = true;
    addBtn.textContent = loadingText;

    try {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      const response = await fetch(`${window.routes.cart_add_url}`, config);
      const data = await response.json();

      if (data.status) {
        throw new Error(data.description || 'Could not add to bag'); // 20 Oct 2026, audit #94
      }

      if (cart) {
        cart.classList.remove('is-empty');
        if (typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        }
        if (typeof cart.open === 'function') {
          cart.open(addBtn);
        }
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'snoozyn-quick-add',
        productVariantId: variantId,
        cartData: data,
      });
    } catch (err) {
      console.error(err);
    } finally {
      addBtn.disabled = false;
      addBtn.textContent = defaultText;
    }
  });
}

/* ---------------------------------------------------------------------------
 * Snoozyn - configurator data repair. 2026-09-03.
 *
 * sections/snoozyn-bundle-builder.liquid emits its data as inline JS:
 *     window.SNZ_CATALOG = JSON.parse(...);
 *     window.SNZ_BUNDLE  = JSON.parse(...);
 *     window.SNZ_MATTRESS_UPGRADE = {{ ...product lookup... }};
 * When a product it interpolates is DRAFT or unpublished, all_products returns
 * nothing, the interpolation renders empty, and the statement becomes invalid
 * JavaScript. A SyntaxError kills the WHOLE inline script, so SNZ_CATALOG is
 * never assigned either and the builder renders every colour as blank with the
 * Add button disabled. Custom Bed Bundle and the Mattress Height Upgrade are
 * deliberately DRAFT, so that is the normal state, not an accident.
 *
 * The JSON blobs themselves are still in the DOM and still valid, so this
 * re-reads them and fills in safe defaults for the rest. It runs synchronously
 * while this deferred script executes, which is after the builder's file has
 * loaded but BEFORE DOMContentLoaded fires, so the builder's own init still
 * sees the data.
 *
 * With no bundle product, SNZ_BUNDLE is {} - every configuration resolves to
 * the itemised parts path, priced from real catalog variants. That is the
 * intended behaviour, not a fallback.
 *
 * This is a shim over a Liquid bug. The durable fix is to guard those
 * interpolations in the section with a default.
 * ------------------------------------------------------------------------ */
(function () {
  function blob(selector, fallback) {
    try {
      var el = document.querySelector(selector);
      if (!el) return fallback;
      var parsed = JSON.parse(el.textContent);
      return parsed || fallback;
    } catch (e) {
      console.warn('[snz-repair] could not parse ' + selector, e);
      return fallback;
    }
  }

  if (!window.SNZ_CATALOG) window.SNZ_CATALOG = blob('[data-snz-catalog-json]', {});
  if (!window.SNZ_BUNDLE) window.SNZ_BUNDLE = blob('[data-snz-bundle-json]', {});
  if (typeof window.SNZ_MONEY_FORMAT !== 'string') window.SNZ_MONEY_FORMAT = '£{{amount}}';
  if (typeof window.SNZ_MATTRESS_UPGRADE === 'undefined') window.SNZ_MATTRESS_UPGRADE = null;
})();

/* ---------------------------------------------------------------------------
 * Snoozyn set identity ("bundle id") + grouped cart rendering - loader.
 * 2026-09-03.
 *
 * The two modules live in their own assets so each can be edited or rolled
 * back on its own. They are injected from HERE because this is the smallest
 * asset the theme loads on every page. Note that a script tag in
 * sections/cart-drawer.liquid does NOT work: the layout renders the cart-drawer
 * SNIPPET directly, so that section file is never rendered.
 *
 * The asset directory is read off any already-loaded /assets/ script rather
 * than hardcoded, so it follows the theme id without a Liquid change. Shopify
 * serves an asset fine without its ?v= cache-buster, which is why the URL is
 * built from the directory only.
 *
 * async = false keeps the two in insertion order, so the fetch wrapper in
 * snoozyn-set-id.js is installed before anything can use it.
 *
 * Delete this block plus the two assets to roll the feature back.
 * ------------------------------------------------------------------------ */
(function () {
  /* 7 Oct 2026: the old test matched the FIRST script whose src contained
   * '/assets/'. On collection, page and cart templates that is Shopify's own
   * /cdn/shopifycloud/storefront/assets/... script, so all four layers below
   * were requested from Shopify's directory and 404'd (no bundle guard, no
   * set-cart grouping, no snz-convert off the PDP and home page). Use this
   * file's own src first, then fall back to a THEME asset path only. */
  var ref = (document.currentScript && document.currentScript.src) || null;
  if (!ref || !/\/t\/\d+\/assets\//.test(ref)) {
    ref = null;
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].src && /\/t\/\d+\/assets\//.test(scripts[i].src)) {
        ref = scripts[i].src;
        break;
      }
    }
  }
  if (!ref) return;
  var dir = ref.slice(0, ref.lastIndexOf('/') + 1);

  /* Shopify's CDN caches an asset by path and ignores query params it does not
   * recognise, so a plain ?bust= does nothing - only ?v= is honoured. These
   * files are injected rather than emitted by Liquid, so they get no digest of
   * their own: BUMP LAYER_V whenever snoozyn-set-id.js or snoozyn-set-cart.js
   * changes, or shoppers keep the previous copy. */
  /* 20 Oct 2026, audit93 H18: LAYER_V bumped (was 25 Sep) so the CDN serves the new snoozyn-set-id.js; loose adds keep their own price. Keep in step with snippets/snz-image-guard.liquid. */
  /* 20 Oct 2026, audit93 BP-2: 20261020b - snoozyn-set-id.js now decorates sets shipped as a named Bedding Set variant. */
  var LAYER_V = "20261020b";

  /* snoozyn-bundle-split.js is pure pricing logic — no DOM, no fetch wrapper.
   * The builder calls it directly, so its position here is not load-bearing;
   * it only has to exist before the first render asks for a covering. The one
   * that DOES wrap window.fetch is snoozyn-real-bundles.js, and it stays last
   * so it is installed outermost, ahead of snoozyn-set-id.js. */

  /* WHICH LAYERS THIS PAGE ACTUALLY NEEDS — 13 Sep 2026.
   *
   * All five used to be injected on every URL. Measured on the live homepage,
   * that cost 752 KB of product JSON on every page load: snoozyn-real-bundles
   * .js boots unconditionally and fetches all EIGHT bedding-set products in
   * parallel (/products/<handle>.js, 71-112 KB each) starting at ~540 ms —
   * inside the LCP window, on a page with no builder on it. The same eight
   * were re-fetched on every PDP, every collection page and every article.
   *
   * The split is by what each file actually does:
   *
   *   ALWAYS   snoozyn-bundle-guard.js, snoozyn-set-id.js, snoozyn-set-cart.js
   *            These serve the CART, which can hold a set on any page.
   *            set-cart groups the lines from their own _snz_set properties
   *            and reads nothing from SNZ_BUNDLE; set-id stamps _snz_config on
   *            add; the guard is a guard. ~19 KB served between them, and not
   *            one of them fetches anything.
   *
   *   BUILDER  snoozyn-bundle-split.js, snoozyn-real-bundles.js
   *            These exist to PRICE a configuration against real variants, and
   *            real-bundles is the one that fetches the eight products.
   *            Nothing outside the builder reads what they publish: split
   *            reads SNZ_REAL_BUNDLES, and real-bundles publishes SNZ_BUNDLE
   *            and installs a /cart/add rewrite that is a plain passthrough
   *            until state.ready — which only becomes true once those eight
   *            fetches land. So off the builder page they were paying for
   *            themselves and delivering nothing.
   *
   * The builder is found by its own root element rather than by path, so a
   * second placement picks the layers up with no further edit here. This file
   * is deferred, so it runs after the document is parsed and the node is there
   * to be found; the path test is a belt-and-braces fallback for a locale
   * prefix or a renamed placement.
   *
   * To put things back exactly as they were, make BUILDER_LAYERS part of
   * ALWAYS_LAYERS again and delete onBuilder.
   */
  var ALWAYS_LAYERS = ['snoozyn-bundle-guard.js', 'snoozyn-set-id.js', 'snoozyn-set-cart.js'];
  var BUILDER_LAYERS = ['snoozyn-bundle-split.js', 'snoozyn-real-bundles.js'];

  var onBuilder = !!document.querySelector('[data-snz-bundle-root]') ||
    String(location.pathname || '').indexOf('/pages/color-combo') !== -1;

  ALWAYS_LAYERS.concat(onBuilder ? BUILDER_LAYERS : []).forEach(function (name) {
    if (document.querySelector('script[data-snz-layer="' + name + '"]')) return;
    var s = document.createElement('script');
    s.src = dir + name + '?v=' + LAYER_V;
    s.async = false;
    s.setAttribute('data-snz-layer', name);
    (document.head || document.documentElement).appendChild(s);
  });

  /* CONVERSION + SPEED LAYERS — 30 Sep 2026.
   *
   *   snz-perf.js     BUILDER only. Makes the builder's unchanged re-renders
   *                   cheap (swatch strip, summary, CSS variables) so a tap
   *                   paints sooner. Never touches builder state or prices.
   *   snz-convert.js  EVERY page. On the builder: the price strip (total,
   *                   delivery, 20% offer) under the step rail, and the
   *                   one-tap "Our pick" bed. Everywhere: the cart drawer's
   *                   delivery line says what applies to this bag.
   *
   * Loaded here for the same reason as the layers above: no Liquid edit, and
   * the directory follows the theme. BUMP CONVERT_V when either file changes.
   * To roll back, delete this block (and the two assets). */
  var CONVERT_V = "20260930a";
  (onBuilder ? ['snz-perf.js', 'snz-convert.js'] : ['snz-convert.js']).forEach(function (name) {
    if (document.querySelector('script[data-snz-layer="' + name + '"]')) return;
    var s = document.createElement('script');
    s.src = dir + name + '?v=' + CONVERT_V;
    s.async = false;
    s.setAttribute('data-snz-layer', name);
    (document.head || document.documentElement).appendChild(s);
  });
})();


/* SNZ product card tap behaviour — moved out of snippets/card-product-enhanced.liquid,
   19 Sep 2026. Was emitted inline once per card (1,030 B each) though the guard meant it
   only ever ran once. Delegated on document, so load order does not matter. */
if (!window.snzTouchInitialized) {
      window.snzTouchInitialized = true;

      document.addEventListener('click', function(event) {
        if (event.target.closest('[data-wishlist-toggle]') || event.target.closest('.snz-product-card__wishlist')) {
          return;
        }

        var card = event.target.closest('.snz-product-card');

        /* 30 Sep 2026: bail out before reading window.innerWidth when there is
           no card involved. Reading innerWidth forces a layout, and this
           listener runs on EVERY click — on the bed builder that was a forced
           layout per tap (and 8-11 per fabric change, which clicks through
           every zone). Behaviour is unchanged: with no card and no open card
           there was nothing to do anyway. */
        if (!card && !document.querySelector('.snz-product-card.is-tapped')) return;

        if (window.innerWidth <= 989) {
          if (card) {
            if (!card.classList.contains('is-tapped')) {
              event.preventDefault();
              event.stopPropagation();

              document.querySelectorAll('.snz-product-card.is-tapped').forEach(function(openCard) {
                openCard.classList.remove('is-tapped');
              });

              card.classList.add('is-tapped');
            }
          } else {
            document.querySelectorAll('.snz-product-card.is-tapped').forEach(function(openCard) {
              openCard.classList.remove('is-tapped');
            });
          }
        }
      }, { capture: true }); 
    }